// TIPOS
export const VIEW = ".view";
export const EDIT = ".edit";
export const DELETE = ".delete";
export const DETAIL = ".detail";
export const NEW = ".new";
export const OPEN = ".open";
export const SEARCH = ".search";
export const SHARE = ".share";
export const NEWFOLDER = ".new_folder";
export const PRINT = ".print";
export const ENABLE = ".enable";
export const DISABLE = ".disable";
export const LOG = ".log";
export const DOWNLOAD = ".download";
export const EDIT_PASSWORD = ".edit_password";
export const UPLOAD = ".upload";
export const EXECUTE = ".execute";
export const MOVE = ".move";
export const CLONE = ".clone";
export const PUBLISH = ".publish";
export const IMPORT = ".import";
export const EXPORT = ".export";
export const NEWVERSION = ".new_version";
export const SIGN = ".sign";
export const SCAN = ".scan";
export const SCANMORE = ".scan_more";
export const DELETEREQUEST = ".delete_request";
export const INVALIDATE = ".invalidate";
export const CHANGE_ORGANIZATION_TENANT = ".change_tenant";
export const RESTORE = ".restore";
export const DRAFT_EDIT = ".draft_edit";
export const DRAFT_DELETE = ".draft_delete";

// Módulos
export const USER = "user";
export const DRIVE = "drive";
export const GROUP = "group";
export const FORM = "form";
export const TASK = "task";
export const MYTASK = "mytask";
export const PROCESS = "process";
export const PROCESSHISTORY = "processhistory";
export const JOB = "job";
export const PLATFORM_STATUS = "platformstatus";
export const MY_PROFILE = "myprofile";
export const THEME = "theme";
export const CONTROL_PANEL = "controlpanel";
export const CATEGORY = "category";
export const REPORT = "report";
export const SCANNING = "scanningprofile";
export const TENANT = "tenant";
export const METADATA = "metadata";
export const OCCUPATION = "occupation";
export const TEMPLATE = "template";
export const DOCUMENT_TYPE = "documenttype";
export const ACCESSPROFILE = "accessprofile";
export const PERMISSION = "permission";
export const MODELER = "modeler";
export const NOTIFICATION = "notification";
export const DOCUMENT = "document";
export const STOCKINGAREA = "stockingarea";
export const CONFIGURATION = "configuration";
export const DOCUMENTARYPENDING = "documentarypending";
export const PROCESSDOCUMENTPENDING = "processdocumentarypending";
export const FOLDER = "folder";
export const LOGAUDIT = "log";
export const MYDOCUMENT = "mydocument";
export const DEGREE = "diploma";
export const DEGREE_STUDENT = "diploma";
export const ARCHIVAL_CLASSIFICATION = "arquivalclassification";
export const BIN = "trash";
export const DATA_LIST = "datalist";
export const API_MANAGER = "apimanager";
export const DATA_LIST_ITEM = "datalist_item";

/**
 * use this when only admin user can accesss
 */
export const IS_ADMIN = ".IS_ADMIN";
